import { render, staticRenderFns } from "./HostingFtp.vue?vue&type=template&id=7f72218f&"
import script from "./HostingFtp.vue?vue&type=script&lang=js&"
export * from "./HostingFtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports